import { useEffect, useState } from 'react';
import apiClient from '../services/api';
import { Logger } from '../utils/logger';
import { todayStatusFrom, TodayAttendanceStatus } from '../utils/todayAttendance';

/**
 * Today's attendance status for a child ('present' | 'absent' | 'leave', null when not marked) -
 * the same call and reading as the header's status chip. The Home screens use it to hide
 * "Class in session" while the child is on leave or absent.
 */
export function useTodayAttendanceStatus(studentId: string | undefined, classId: string | undefined): TodayAttendanceStatus {
  const [status, setStatus] = useState<TodayAttendanceStatus>(null);

  useEffect(() => {
    setStatus(null);
    if (!studentId || !classId) return;

    let isMounted = true;
    (async () => {
      try {
        const today = new Date();
        const res = await apiClient.get(
          `/student/attendance/student/${studentId}/class/${classId}?year=${today.getFullYear()}&month=${today.getMonth() + 1}`
        );
        if (isMounted) setStatus(todayStatusFrom(res.data, today));
      } catch (err) {
        Logger.warn('TodayAttendance', 'Failed to fetch today\'s attendance', err);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [studentId, classId]);

  return status;
}
